import { ComponentProps, useMemo } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const QuickFeedbackButton = ({
  children,
  hoverIcon,
  isActive = false,
  isButton,
  size,
  ...restProps
}: ComponentProps<typeof Box<'button'>> & {
  hoverIcon: JSX.Element;
  isActive: boolean | undefined;
  isButton: boolean;
  size: number;
}): JSX.Element => {
  const theme = useTheme();

  const iconSx = useMemo(() => {
    return {
      height: `${size}px`,
      width: `${size}px`,
    };
  }, [size]);

  const containerSize = useMemo(() => `${size * 1.33}px`, [size]);

  return isButton ? (
    <Box
      sx={{
        '& .hover-icon': {
          display: 'none',
        },

        ':focus, :hover': {
          '& .default-icon': {
            display: 'none',
          },
          '& .hover-icon': {
            display: 'initial',
          },

          boxShadow: '0px 0px 4px 0px #00000040',
          outline: 'none',
        },

        alignItems: 'center',
        backgroundColor: theme.palette.colors.slate[100],
        border: 'none',
        borderRadius: '50%',
        boxShadow: isActive ? '0px 0px 4px 0px #00000040' : undefined,
        color: theme.palette.text.primary,
        cursor: 'pointer',
        display: 'flex',
        height: containerSize,
        justifyContent: 'center',
        padding: 0,
        width: containerSize,
      }}
      {...restProps}
    >
      <Box className='default-icon' style={iconSx}>
        {children}
      </Box>
      <Box className='hover-icon' style={iconSx}>
        {hoverIcon}
      </Box>
    </Box>
  ) : (
    <Box color={theme.palette.colors.grey[500]}>{children}</Box>
  );
};

export default QuickFeedbackButton;
